<div class="row">
    <div class="col-xl-4">
        <a [routerLink]="" class="card card-box mb-5">
            <div class="card-body">
                <div class="align-box-row align-items-start">
                    <div class="mr-3">
                        <div class="bg-happy-fisher text-center text-white font-size-xl d-50 rounded-circle">
                            <fa-icon [icon]="['far', 'dot-circle']"></fa-icon>
                        </div>
                    </div>
                    <div>
                        <div class="font-weight-bold">
                            <small class="text-black-50 d-block mb-1 text-uppercase">Sales</small>
                            <span class="font-size-xxl mt-2">23,274</span>
                        </div>
                        <div class="mt-2">
                            <fa-icon [icon]="['fas', 'arrow-up']" class="text-success"></fa-icon>
                            <span class="text-success px-1">15.4%</span>
                            <span class="text-black-50">increase</span>
                        </div>
                    </div>
                    <div class="ml-auto card-hover-indicator align-self-center">
                        <fa-icon [icon]="['fas', 'chevron-right']" class="font-size-xl"></fa-icon>
                    </div>
                </div>
            </div>
        </a>
    </div>
    <div class="col-xl-4">
        <a [routerLink]="" class="card card-box mb-5 bg-night-sky text-white border-0">
            <div class="card-body">
                <div class="align-box-row align-items-start">
                    <div class="mr-3">
                        <div class="bg-white text-center text-success font-size-xl d-50 rounded-circle">
                            <fa-icon [icon]="['far', 'building']"></fa-icon>
                        </div>
                    </div>
                    <div>
                        <div class="font-weight-bold">
                            <small class="text-white-50 d-block mb-1 text-uppercase">New Accounts</small>
                            <span class="font-size-xxl mt-2">586,356</span>
                        </div>
                        <div class="mt-2">
                            <fa-icon [icon]="['fas', 'arrow-up']" class="text-success"></fa-icon>
                            <span class="text-success px-1">15.4%</span>
                            <span class="text-white-50">increase</span>
                        </div>
                    </div>
                    <div class="ml-auto card-hover-indicator align-self-center">
                        <fa-icon [icon]="['fas', 'chevron-right']" class="font-size-xl"></fa-icon>
                    </div>
                </div>
            </div>
        </a>
    </div>
    <div class="col-xl-4">
        <a [routerLink]="" class="card card-box mb-5 card-box-border-bottom border-danger">
            <div class="card-body">
                <div class="align-box-row align-items-start">
                    <div class="mr-3">
                        <div class="bg-danger text-center text-white font-size-xl d-50 rounded-circle">
                            <fa-icon [icon]="['far', 'keyboard']"></fa-icon>
                        </div>
                    </div>
                    <div>
                        <div class="font-weight-bold">
                            <small class="text-black-50 d-block mb-1 text-uppercase">Orders</small>
                            <span class="font-size-xxl text-danger mt-1">345</span>
                        </div>
                        <div class="mt-2">
                            <fa-icon [icon]="['fas', 'arrow-down']" class="text-danger"></fa-icon>
                            <span class="text-danger px-1">5.9%</span>
                            <span class="text-black-50">less orders</span>
                        </div>
                    </div>
                    <div class="ml-auto card-hover-indicator align-self-center">
                        <fa-icon [icon]="['fas', 'chevron-right']" class="font-size-xl"></fa-icon>
                    </div>
                </div>
            </div>
        </a>
    </div>
</div>